import { Data as ArticleData } from '@root/modules/article/types/article';

export const getArticlePaywallState = (article: ArticleData | null): { enabled: boolean; access: boolean } => {
  const enabled = article?.content.paywall.enabled ?? false;
  const access = article?.content.paywall.access || false;

  return {
    enabled,
    access,
  };
};
